/* eslint-disable */
export default {
    inserted: function(el) {
        let allTabPanels = el.querySelectorAll('[role="tabpanel"]');
        let tabList = el.querySelector('[role="tablist"]');

        // The current version of bootstrap-vue being used (1.51.1) looks to have a misspelling when adding the 'aria-labelledby' attribute on the tabpanels causing an accessibility risk flag.  Removing the misspelled attribute and adding the correct spelling with the appropriate value here.
        allTabPanels.forEach( tabPanel => {
            window.setTimeout(() => {
                tabPanel.setAttribute('aria-labelledby', tabPanel.attributes.getNamedItem('aria-lablelledby').value);
                tabPanel.removeAttribute('aria-lablelledby');
            }, 0);
        });

        // Move focus to the next tab in the tab list when tabbing from the last tabbable element within a tab panel on desktop with screen reader announcement.  Do not do this if it is the last tab panel.
        for (let i = 0; i < allTabPanels.length - 1; i++) {
            let allTabbableElements = allTabPanels[i].querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
            let lastTabbableElement = allTabbableElements[allTabbableElements.length - 1];

            lastTabbableElement.addEventListener('keydown', e => {
                let allTabs;

                if(tabList) {
                    allTabs = tabList.querySelectorAll('.nav-item');
                }

                if((e.keyCode === 9 && !e.shiftKey) && allTabs && window.innerWidth > 575) {
                    e.preventDefault();
                    allTabs[i + 1].querySelector('[role="tab"]').setAttribute('tabindex', '0');
                    allTabs[i + 1].querySelector('[role="tab"]').click();
                    allTabs[i + 1].querySelector('[role="tab"]').focus();
                    allTabs[i].querySelector('[role="tab"]').setAttribute('tabindex', '-1');
                }
            });
        }

        // // Enable screen readers to announce the tabs while navigating them via arrow keys.  The current version of bootstrap-vue being used (1.51.1) does support this.  Navigating with the down arrow key is also broken because of a misspelling in file Project\Heart-FrontEnd\node_modules\bootstrap-vue\es\components\tabs\tabs.js on line 245 (KeyCodes.DWON).
        setTimeout( () => {
            if (tabList) {
                let initialActiveTab = tabList.querySelector('.active');
                let allListItems = tabList.querySelectorAll('li');

                allListItems.forEach( listItem => {
                    listItem.removeAttribute('role');
                });

                // Remove tabindex=0 on tab list
                if(tabList) {
                    tabList.removeAttribute('tabindex');
                }
                // Set tabindex=0 on the active tab when loaded
                if(initialActiveTab) {
                    initialActiveTab.setAttribute('tabindex', '0');
                }

                tabList.addEventListener('keydown', e => {
                    let currentTab;

                    if(e.target.classList.contains('nav-link') && (e.keyCode === 39 || e.keyCode === 40)) {
                        currentTab = e.target;
                        let nextTab = currentTab.parentNode.nextElementSibling ? currentTab.parentNode.nextElementSibling.querySelector('.nav-link') : null;

                        if(nextTab) {
                            currentTab.setAttribute('tabindex', '-1');
                            nextTab.setAttribute('tabindex', '0');
                            nextTab.click();
                            nextTab.focus();
                        }
                    } else if(e.target.classList.contains('nav-link') && (e.keyCode === 37 || e.keyCode === 38)) {
                        currentTab = e.target;
                        let previousTab = currentTab.parentNode.previousElementSibling ? currentTab.parentNode.previousElementSibling.querySelector('.nav-link') : null;

                        if(previousTab) {
                            currentTab.setAttribute('tabindex', '-1');
                            previousTab.setAttribute('tabindex', '0');
                            previousTab.click();
                            previousTab.focus();
                        }
                    }
                });
                // Set tabindex=0 on a tab when it is clicked and set tabindex=-1 on the currently active tab.  Listening to 'mouseup' as bootstrap-vue is preventing propagation of 'click' event in their Tab component.
                tabList.addEventListener('mouseup', e => {
                    let currentActiveTab = tabList.querySelector('.active');

                    if(currentActiveTab) {
                        currentActiveTab.setAttribute('tabindex', '-1');
                    }

                    if(e.target.classList.contains('nav-link')) {
                        e.target.setAttribute('tabindex', '0');
                    }
                });
            }
        }, 0)

    },
};



// WEBPACK FOOTER //
// ./src/app/directives/tabs-custom-tabbing.js